import React from "react";
import { Route, Redirect } from "react-router-dom";
import BaseTemplate from "./BaseTemplate";

function ProtectedRoute({ auth: auth, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (auth) {
          return (
            <BaseTemplate>
              <Component />
            </BaseTemplate>
          );
        } else {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }
      }}
    />
  );
}
export default ProtectedRoute;
